import { useEffect, useState } from "react";

export const EstadoBasicoSelect = ({
  name,
  value,
  onChange
}) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-estatus"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CC">Consolidado</option>
      <option value="PE">Pendientes de envío</option>
      <option value="EN">Mensajes enviados</option>
      <option value="EM">Esperando respuesta</option>
      <option value="LE">Mensajes Leidos</option>
      <option value="RL">Respuesta escrita</option>
      <option value="CI">Clientes con interes</option>
      <option value="SI">Clientes sin interes</option>
      <option value="ER">Ocurrio un error</option>
    </select>
  );
};
